import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginDialogComponent } from '../../modalDialogs/logindialog/logindialog.component';
import { ResetbasketwarningdialogComponent } from '../../modalDialogs/resetBasketWarningDialog/resetBasketWarningDialog.component';
import { BottomSheetHelperService } from '../../services/bottomSheetHelper.service';
import { CoreLanguageService } from '../../services/language.service';
import { CoreLogService } from '../../services/log.service';
import { RouterHelperService } from '../../services/routerHelper.service';
import { snackBarMessageKey, SnackBarService } from '../../services/snackBar.service';
import { UserHelperService } from '../../services/userHelper.service';
import { WebShopService } from '../../services/webShop.service';
import { SnackBarMessageType, VoucherServiceType, WebShopMode } from '../../shared/contentTypes';
import { LocationService } from '../location/location.service';
import { Location } from "@angular/common";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";

@Component({
  selector: 'ya-vouchercredit',
  templateUrl: './voucherCredit.component.html',
  styleUrls: ['./voucherCredit.component.scss'],
  animations: [
    trigger("serviceButtonEntering", [
      transition("false => true", [
        query(".service-button", [
          style({ transform: "scale(0)" }),
          stagger(100, [
            animate("400ms ease-out", style({ transform: "scale(1.1)" })),
            animate("100ms ease-in-out", style({ transform: "scale(1)" }))
          ])
        ])
      ])
    ]),
  ]
})

export class VoucherCreditComponent implements OnInit {
  public isLoaded: boolean = false;
  public useBrowserHistory: boolean = true;
  public voucherServiceType = VoucherServiceType;
  public webShopMode = WebShopMode;
  public isSmallView: boolean = false;

  constructor(private _router: Router
    , private _coreLanguageService: CoreLanguageService
    , private _location: Location
    , private _activatedRoute: ActivatedRoute
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _userHelperService: UserHelperService
    , private _routerHelperService: RouterHelperService
    , private _coreLogService: CoreLogService
    , private _snackBarService: SnackBarService
    , private _webShopService: WebShopService
    , _mainnavService: MainnavService) {
    this.isSmallView = _mainnavService.viewType === ViewType.Small;
  }

  ngOnInit() {
    const me = this;
    me.setRouteData();
    setTimeout(() => {
      me.isLoaded = true;
    }, 100);
  }

  private setRouteData() {
    const me = this;
    const routeTargetData = me._activatedRoute.snapshot.data["routeTargetData"];
    if (routeTargetData && !routeTargetData["useBrowserHistory"]) {
      me.useBrowserHistory = routeTargetData["useBrowserHistory"];
    }
  }

  public setVoucherService(voucherServiceType: VoucherServiceType) {
    const me = this;
    if (voucherServiceType === VoucherServiceType.Charge) {
      if (!me._userHelperService.IsRegistered) {
        me._bottomSheetHelperService.open(LoginDialogComponent);
      } else {
        me._userHelperService.HasWebVoucher()
          .then((hasWebVoucher) => {
            if (!hasWebVoucher) {
              me._routerHelperService.setRouteTargetDataByKey("returnUrl", me._router.url);
              me._router.navigate(["/webvoucher"]);
            } else {
              me.checkSingleLocation(voucherServiceType);
            }
          })
          .catch(error => {
            me._coreLogService.error("VoucherCreditComponent.setVoucherService", "_userHelperService.HasWebVoucher", error);
            me._snackBarService.ShowErrorMessageFailed(93);
          })
      }
    } else {
      me.checkSingleLocation(voucherServiceType);
    }
  }

  private checkSingleLocation(voucherServiceType: VoucherServiceType) {
    const me = this;
    me._webShopService.setServiceMode(WebShopMode.Webvoucher, true, voucherServiceType)
      .then(serviceMode => {
        if (serviceMode !== null) {
          me._webShopService.HasSingleLocation(serviceMode)
            .then(response => {
              if (response) {
                me._webShopService.tryAndRouteToSingleVariableWebvoucher();
              } else {
                me._router.navigate(["/menulocation"]);
              }
            })
            .catch(e => {
              me._coreLogService.error("VoucherCreditComponent.checkSingleLocation", "_webShopService.HasSingleLocation", e);
              me._snackBarService.ShowErrorMessageFailed(94);
            });
        } else {
          me._coreLogService.error("VoucherCreditComponent.checkSingleLocation", "serviceMode invalid/null", serviceMode);
          me._snackBarService.ShowErrorMessageFailed(95);
        }
      })
      .catch(e => {
        me._coreLogService.error("VoucherCreditComponent.checkSingleLocation", "_webShopService.setServiceMode", e);
        me._snackBarService.ShowErrorMessageFailed(96);
      });
  }

  public checkService(voucherServiceType: VoucherServiceType) {
    const me = this;

    me._webShopService.openWarningResetBasketDialogIfNeed(me._webShopService.locationID, WebShopMode.Webvoucher, (agree) => {
      if (agree) {
        me.setVoucherService(voucherServiceType);
      } /* else do nothing */
    });
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  public navigateBack() {
    const me = this;
    if (me.useBrowserHistory) {
      me._location.back();
    } else {
      me._router.navigate(["/menuservice"], { replaceUrl: true });
    }
  }
}
